/**
 * @module app.core
 */

import * as Core from 'app/core/models/essette-api';
import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { validatePhoneNumber } from 'app/shared/lib/validation/validation-utilities';
import { guid } from 'app/shared/lib/guid';


@autoinject()
export class EditPhoneNumberCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected id: guid = guid();

    @bindable.object({ defaultBindingMode: bindingMode.twoWay })
    public phoneNumber: Core.PhoneNumber = {};

    @bindable.stringNull()
    public icon: string | null = null;

    @bindable.stringNull()
    public label: string | null = null;

    @bindable.boolean()
    public required: boolean = false;

    @bindable.boolean()
    public readonly: boolean = false;

    @bindable.string()
    protected labelIconTooltip: string | null = null;

    protected validatePhoneNumber = validatePhoneNumber;



    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }


    ////****************** Events ***************************************************////



    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
